import { MinLength, MaxLength } from "class-validator";
import {validate, validateOrReject, Contains, IsInt, Length, IsEmail, IsFQDN,
        IsDate,Min,Max } from "class-validator"; 
import {ValidateIf, IsNotEmpty,IsNumber,IsString,IsEmpty } from "class-validator"; 


export class Utysa { 
    @MaxLength(10,{message: 'COMPANY 字串太長'}) 
    @IsString({message: 'COMPANY 不是字串型態'}) 
    COMPANY: string = ""; 
  
    @MaxLength(10) 
    CREATOR: string = ""; 
  
    @MaxLength(10) 
    USR_GROUP: string = ""; 
  
    @MaxLength(8) 
    CREATE_DATE: string =""; 
  
    @MaxLength(10) 
    MODIFIER: string = ""; 
  
    @MaxLength(8) 
    MODI_DATE: string = ""; 
  
    @IsNumber() 
    @Max(999) 
    FLAG: number =0; 


    @IsNotEmpty({message: '主資料表 (SA001) 不可空白'}) 
    @MaxLength(50,{message: '主資料表 (SA001) 資料太長'})
    SA001: string = '';            // 主資料表 50 join OpenWin.MainTable

    @IsNotEmpty({message: '序號 (SA002) 不可空白'}) 
    @MaxLength(50,{message: '序號 (SA002) 資料太長'})
    SA002: string = '';            // 序號 50 join OpenWin.ITEM  OpenWin.TYPE 一定是 U

    @IsNotEmpty({message: '使用者代號 (SA003) 不可空白'}) 
    @MaxLength(20,{message: '使用者代號 (SA003) 資料太長'})
    SA003: string = '';            // 使用者代號 20 join SYSUser.UserID

    @MaxLength(20,{message: '保留 (SA004) 資料太長'})
    SA004: string = '';            // 保留 20 單身序號

    @MaxLength(255,{message: '備註 (SA005) 資料太長'})
    SA005: string = '';            // 備註 255 


}
